<div class="content">

    <h2 class="dialog-title">{{dialogData['title']}}</h2>
    <div class="dialog-content">
        <div class="maincontainer">
            <nz-tabs>
                <nz-tab [nzTitle]="'meli.form.attributes'|translateTA">
                    <div class="list-content">
                        <ul>
                            <li *ngFor="let item of result['attributes']">
                                <b>{{item.name}}:</b> {{ item.value_name}}
                            </li>
                        </ul>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="'meli.form.step.var'|translateTA">
                    <div class="variation_body">
                        <meli-variation [melidata]="(resultOb.asObservable() | async)"></meli-variation>
                    </div>
                </nz-tab>
            </nz-tabs>

            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='attribspinner'>
            </ngx-spinner>
        </div>
    </div>
    <div class="dialog-actions">
        <button nz-button nzType="primary" [mat-dialog-close]="true" cdkFocusInitial>{{'meli.item.ok'|translateTA}}</button>
    </div>

</div>
